(function (app, ng) {
    app.component('myCarriersComponent',
        {
            templateUrl: 'App.Portal/States/CarriersTraining/Components/MyCarriers/MyCarriers.template.html',
            controller: 'MyCarriersController',
            bindings: {
                showAppointments: '='
            }
        })
        .controller('MyCarriersController', ['_','$cookies', 'reportsApi', '$filter',
            function (_, $cookies, reportsApi, $filter) {
                var $ctrl = this;

                ng.extend($ctrl, {
                    ui: {
                        loading: false
                    },
                });

                $ctrl.getStateAppointments = function (contract) {
                    if (contract.ShowDetails) {
                        contract.ShowDetails = false;
                        return;
                    }

                    contract.GettingDetails = true;

                    reportsApi.getStateAppointments(contract.ContractGuid, contract.LineOfBusinessGuid).then(function (data) {
                        contract.GettingDetails = false;
                        contract.ContractDetails = data;
                        contract.ShowDetails = true;
                    });
                };

                $ctrl.getSubAgents = function () {
                    reportsApi.getSubAgents().then(function (data) {
                        $ctrl.SubAgents = data;
                    });
                };

                $ctrl.exportContractReport = function () {
                    $ctrl.exportingList = true;
                    var agentGuids =
                        _.map(_.filter($ctrl.SubAgents), "ChildAgentGuid");

                    var agentIds = "";
                    for (var i = 0; i < agentGuids.length; i++) {
                        agentIds += agentGuids[i];
                        if (i < agentGuids.length - 1)
                            agentIds += ",";
                    }
                    var model = { AgentIds: agentIds };

                    return reportsApi.exportContractReport(model).then(function (data) {
                        $ctrl.exportingList = false;

                        downloadFile(data);
                    });
                };

                $ctrl.orderRows = function (columnName) {
                    if (columnName) {
                        $ctrl.reverseOrder = (columnName === $ctrl.columnName) ? !$ctrl.reverseOrder : false;
                        $ctrl.columnName = columnName;
                    } else {
                        columnName = $ctrl.columnName;
                    }
                    $ctrl.myCarrierList = $filter('orderBy')($ctrl.myCarrierList, columnName, $ctrl.reverseOrder);
                };

                function downloadFile(data) {
                    var f = document.createElement("a");
                    f.id = "tmpDownload-" + ++$ctrl.downloadIncrement;
                    document.body.appendChild(f);
                    f.style = "display: none";

                    var fUrl = window.URL.createObjectURL(data);
                    f.href = fUrl;
                    f.download = "ContractData.xlsx";
                    f.click();

                    setTimeout(function () {
                        var el = document.getElementById(f.id);
                        document.body.removeChild(el);
                        window.URL.revokeObjectURL(fUrl);
                    },
                        100);
                }

                $ctrl.$onInit = function () {
                    $ctrl.columnName = 'Carrier';
                    $ctrl.downloadIncrement = 0;
                    $ctrl.ui.loading = true;
                    reportsApi.getContracts()
                        .then(function (result) {
                            $ctrl.showAppointments = true;
                            $ctrl.myCarrierList = _(result)
                                .map(function (r) {
                                    var carrier = {
                                        ContractDetails: {},
                                        GettingDetails: false,
                                        ShowDetails: false,
                                    };
                                    ng.copy(r, carrier);
                                    return carrier;
                                })
                                .map(function (carrier) {
                                    var indvNumbers = !carrier.WritingNumbers ? [] : carrier.WritingNumbers.split(', ').map(function (number) {
                                        return {
                                            value: number,
                                            type: 'Individual',
                                            icon: 'fig-account',
                                        }
                                    });
                                    var corpNumbers = !carrier.CorpWritingNumbers ? [] : carrier.CorpWritingNumbers.split(', ').map(function (number) {
                                        return {
                                            value: number,
                                            type: 'Corporate',
                                            icon: 'fig-briefcase',
                                        }
                                    });

                                    return Object.assign(carrier, {
                                        WritingNumberArray: indvNumbers.concat(corpNumbers),
                                    })
                                })
                                .value();
                        })
                        .catch(function (error) {
                            $ctrl.showAppointments = false;
                        })
                        .finally(function () {
                            $ctrl.ui.loading = false;
                        });
                };

            }]);
})(window.app, window.angular); //jshint ignore:line